import type { JSX } from 'react';

/**
 * @component SDSImageWrapper
 * A simple wrapper component primarily used to conditionally wrap its children
 * in a `div` with a specified CSS class. If no `wrapperClassName` is provided,
 * it renders the children directly using a React Fragment without adding an
 * extra DOM element. This is useful for components like SDSImage or SDSServerImage
 * that might sometimes need an outer container for styling or layout purposes
 * (e.g., maintaining aspect ratio).
 */
export function SDSImageWrapper({ wrapperClassName, children }: { wrapperClassName?: string; children: JSX.Element }) {
  // If a wrapper class name is provided, wrap children in a div with that class.
  if (wrapperClassName) {
    return <div className={wrapperClassName}>{children}</div>;
  }

  // Otherwise, render children directly, avoiding an unnecessary DOM element.
  return children;
}
